var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApliances(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000610352,
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.474 15.4001H30.4C30.7314 15.4001 31 15.6687 31 16.0001V26.2001C31 26.5314 30.7314 26.8001 30.4 26.8001H24.1V28.0001H26.2C26.5314 28.0001 26.8 28.2687 26.8 28.6001C26.8 28.9314 26.5314 29.2001 26.2 29.2001H17.8C17.4686 29.2001 17.2 28.9314 17.2 28.6001C17.2 28.2687 17.4686 28.0001 17.8 28.0001H19.9V26.8001H13.6C13.2686 26.8001 13 26.5314 13 26.2001V16.0001C13 15.6687 13.2686 15.4001 13.6 15.4001H24.4461C24.4554 15.3998 24.4647 15.3998 24.474 15.4001ZM24.3538 18.066L24.8817 16.6001H29.8V23.6501H14.2V16.6001H23.6062L22.9355 18.4627C22.8693 18.6465 22.8968 18.8511 23.0091 19.011C23.1215 19.1708 23.3046 19.266 23.5 19.266H24.4184L23.7818 20.8799C23.6603 21.1882 23.8116 21.5366 24.1199 21.6582C24.4281 21.7798 24.7766 21.6285 24.8982 21.3202L25.8582 18.8861C25.931 18.7014 25.9078 18.4926 25.796 18.3284C25.6843 18.1642 25.4986 18.066 25.3 18.066H24.3538ZM14.2 24.8501V25.6001H20.5H23.5H29.8V24.8501H14.2ZM22.9 28.0001H21.1V26.8001H22.9V28.0001Z",
    fill: "url(#paint0_linear_1392_6245)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1392_6245",
    x1: 22,
    y1: 15.3999,
    x2: 22,
    y2: 29.2001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApliances);
export default __webpack_public_path__ + "static/media/apliances.025e0d669376a05f07932129a91a28e1.svg";
export { ForwardRef as ReactComponent };